import React from 'react';
import ExternalDashboard from '../components/ExternalDashboard';
import { getSiteById } from '../config/sites';

const CascadeMS = () => {
  const siteConfig = getSiteById('cascade-ms');
  return <ExternalDashboard config={siteConfig} />;
};

export default CascadeMS;
